import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentConfigService } from '../services/environment-config.service';

@Injectable()
export class ApiKeyInterceptor implements HttpInterceptor {
  
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Clone the request to modify it
    const modifiedReq = req.clone({
      setHeaders: {
        'Ocp-Apim-Subscription-Key': EnvironmentConfigService.getApiGatewayConfig().OCP_APIM_SUBSCRIPTION_KEY
      }
    });

    // Pass the modified request on to the next handler
    return next.handle(modifiedReq);
  }
}
